import React from 'react';
import { FDIcon, FDPaper } from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';

const getSize = (size) => {
  switch (size) {
    case 'sm':
      return { icon: '24px', border: '43px', background: '39px' };
    case 'lg':
      return { icon: '48px', border: '86px', background: '78px' };
    case 'md':
    default:
      return { icon: '32px', border: '58px', background: '52px' };
  }
};

const useStyles = buildUseStyles('PillarProgressIcon', () => ({
  border: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    height: ({ size }) => getSize(size).border,
    width: ({ size }) => getSize(size).border,
    background: 'linear-gradient(180deg, #E9DC9B 0%, #BEB481 100%)',
    flexShrink: 0,
  },
  root: {
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: ({ size }) => getSize(size).background,
    width: ({ size }) => getSize(size).background,
    '& svg': {
      fontSize: ({ size }) => getSize(size).icon,
    },
    // This component sets its own background color and box shadow. This is not ideal because it doesn't allow
    // FD to have full control over the palette that is used for the FDIcon that is a child. If this paper is not
    // transparent it partially covers the box shadow
    '& .FD-MuiPaper-root': {
      backgroundColor: 'transparent',
    },
  },
  shadow: {
    position: 'absolute',
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    boxShadow: '0px 0px 10px 18px #00000024',
  },
}));

export const PillarProgressIcon = ({ size, icon }) => {
  const classes = useStyles({ size });
  return (
    <div className={classes.border}>
      <div className={classes.root}>
        <div className={classes.shadow} />
        {/* This FDPaper will set the drawing surface to 'default' which will allow the icon to be Oceana500 as desired.
        Unfortunately this component manually adjusts its own background color so FD is unaware that a different palette
        must be used for downstream icons. We should avoid manually adjusting background color in the webapp and should
         instead use tools that FD makes available like FDPaper to draw on different colored surfaces */}
        <FDPaper appearance={'flat'}>
          <FDIcon icon={icon} size={'lg'} color={'primary'} />
        </FDPaper>
      </div>
    </div>
  );
};

PillarProgressIcon.defaultProps = {
  size: 'md',
  icon: 'lock',
};

PillarProgressIcon.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  icon: PropTypes.oneOf(['lock', 'check']),
};
